import React, { useState } from 'react';
import { Input, Toggle, TextArea, Dropdown, Select } from 'selfly-ui-react';
import NewSelect from '../Select/Select';

import './validating-input.scss';

export default function ValidatingInput(props) {
    const [initVal] = useState(props.dataSet[props.dataKey]);
    const [value, setValue] = useState(initVal);
    const [valid, setValidity] = useState(true);

    function changeEventHandler(e) {
        change(e.currentTarget.value);
    }

    function change(curVal) {
        let sendValue = curVal;
        let isValid = true;
        if (typeof props.validationFn === 'function') {
            isValid = props.validationFn(curVal);
            // console.log("Custom validation for ",props.label, curVal, isValid);
        } else {
            switch (props.validationType) {
                case 'string':
                    isValid = typeof curVal === 'string';
                    break;
                case 'float':
                    isValid = curVal.length === 0 ? false : isNaN(curVal) ? false : true;
                    sendValue = parseFloat(curVal);
                    break;
                case 'integer':
                    isValid = curVal.length === 0 ? false : isNaN(curVal) ? false : Number.isInteger(Number(curVal)) ? true : false;
                    sendValue = parseInt(curVal);
                    break;
                case 'boolean':
                    isValid = curVal === true || curVal === false;
                    break;
                case 'text':
                    isValid = true;
                    break;
                case 'json':
                    try {
                        JSON.parse(curVal);
                        // console.log("VALID JSON", curVal);
                        isValid = true;
                    } catch (err) {
                        // console.log("INVALID JSON", curVal);
                        isValid = false;
                    }
                    break;
                case 'select':
                    break;
                case 'multiSelect':
                    break;
                default:
                    break;
            }
        }

        props.onChange(props.dataKey, sendValue, isValid);
        setValidity(isValid);
        setValue(curVal);
    }

    if (initVal === undefined) {
        return null;
    }

    if (props.validationType === 'boolean') {
        return (
            <div className="se-input-container validating-input">
                <label className="se-label">{props.label}</label>
                <Toggle isActive={value} onChange={change} id={props.id} />
            </div>
        );
    }

    if (props.validationType === 'dropdown') {
        return (
            <div className="se-input-container validating-input">
                <Dropdown label={props.label} options={props.options} value={value} id={props.id} />
            </div>
        );
    }

    if (props.validationType === 'select') {
        const selectValue = props.valueObject ? props.valueObject : value;
        return (
            <div className={`se-input-container validating-input`}>
                <label className="se-label">{props.label}</label>
                <Select
                    options={props.options}
                    defaultValue={selectValue}
                    id={props.id}
                    onChange={change}
                    className={!valid ? 'invalid' : value === initVal ? 'original' : 'changed'}
                />
            </div>
        );
    }

    if (props.validationType === 'multiSelect') {
        const selectValue = props.valueObject ? props.valueObject : value;
        return (
            <div className={`se-input-container validating-input`}>
                <label className="se-label">{props.label}</label>
                <NewSelect
                    options={props.options}
                    value={selectValue}
                    onChange={change}
                    className={!valid ? 'invalid' : value === initVal ? 'original' : 'changed'}
                    multiselect={true}
                />
            </div>
        );
    }

    if (props.validationType === 'text') {
        return <TextArea label={props.label} placeholder="Enter ext" value={value} onChange={changeEventHandler} id={props.id} className="validating-input" />;
    }

    if (props.validationType === 'json') {
        return (
            <TextArea
                label={props.label}
                placeholder="Enter Json"
                value={value}
                onChange={changeEventHandler}
                className={!valid ? 'validating-input invalid' : value === initVal ? 'original validating-input' : 'changed validating-input'}
                id={props.id}
            />
        );
    }

    return (
        <Input
            label={props.label}
            value={value}
            onChange={changeEventHandler}
            className={!valid ? 'validating-input invalid' : value === initVal ? 'original validating-input' : 'changed validating-input'}
            id={props.id}
        />
    );
}
